/* global asdomarProduct */

function formatSlideContent(format){
	return `
<div class="product-head">
		<figure class="pack">
			<img src="${format.formatPackSrc}">
		</figure>
		<div class="copy">
			<h1 class="double-title">
				<span class="impact">${format.format_name.first_line}</span>
				<span class="gentle">${format.format_name.last_line}</span>
			</h1>
			<span class="format"><strong>${format.format_weight}</strong> gr</span>
		</div>
</div>`;
}


(function($){



		var ctx = document.getElementById("doughnut");
		var $ctx = $(ctx);


		var data = {
			labels: [
				"Red",
				"Blue",
				"Yellow"
			],
			datasets: [
				{
					data: [
						$ctx.attr('data-proteins'),
						$ctx.attr('data-fats'),
						$ctx.attr('data-carbs'),
						$ctx.attr('data-salt'),
						$ctx.attr('data-fibers'),
					],
					backgroundColor: [
						"#e2ca6b",
						"#e39666",
						"#dee0df",
						"#69b6dc",
						"#d75e46"
					],
				}
			]
		};

		var options ={
			legend: {
				'display': false
			},
			cutoutPercentage: 75
		};



	$ctx.on('lazyWokeUp', function(){
		console.log('render');
			/* global Chart */
		var myDoughnutChart = new Chart(ctx, {
		type: 'doughnut',
		data: data,
		options: options
		});
	});




	$('.share-fb').on('click', function(e){
		e.preventDefault();
		/* global FB */
		FB.ui(
		{
		method: 'share',
		href: window.location.href
		}, function(response){});

	});


	$('.share').on('click', function(e){
		e.preventDefault();
		$(this).addClass('intent');
	});

	const asd = function(){console.log('loaded');};

	$('#formats-link').on('click', function(e){
		e.preventDefault();

		$('body').addClass('overlay-visible loading');

		var formatSlider = document.createElement('aside');
		formatSlider.className = 'formats-slider owl-carousel';
		formatSlider.id = 'formats-slider';

		var formatSliderCloseButton = document.createElement('button');
		formatSliderCloseButton.className = 'close';
		formatSliderCloseButton.id = 'close';

		$(formatSliderCloseButton).on('click',function(){
			$('body').removeClass('overlay-visible');
			$('#overlay').empty();
		});

		for (let format of asdomarProduct) {
			let slide = document.createElement('div');
			slide.className = 'format-slide';
			slide.innerHTML = formatSlideContent(format);
			formatSlider.appendChild(slide);
		}

		document.getElementById('overlay').appendChild(formatSlider);

		let $images = $('#overlay img');

		let totalImages = $images.length;
		let loadedImages = 0;

		$('#overlay img').on('load', function(){
			loadedImages++;

			if (totalImages === loadedImages) {
				$('.formats-slider').owlCarousel({
					items: 1,
					nav: true,
					loop: false,
				}).append(formatSliderCloseButton);
			}
		});
	});
})(jQuery);